<template>
  <TopNavigatorBar ref="topNavBarDOMTag" :highlightIndex="1"/>
  <div class="v-space1"></div>
  <FaceSwapEditSection/>
  <div class="v-space2"></div>
  <FaceSwapHeader/>
  <div class="v-space3"></div>
  <FaceSwapYTBVideo/>
  <div class="v-space3"></div>
  <FaceSwapIntroduceSection/>
  <div class="v-space4"></div>
  <FaceSwapGuideSection/>
  <div class="v-space5"></div>
  <FaceSwapReviewSection/>
  <div class="v-space6"></div>
  <FaceSwapFAQSection/>
  <BottomBar/>
  <div class="v-space-extra" v-if="faceSwap.selectedFiledIndex >= 0"></div>
</template>

<script setup>
import TopNavigatorBar from '@/components/TopNavigatorBar.vue';
import BottomBar from '@/components/BottomBar.vue';
import FaceSwapHeader from '@/components/faceSwapIndex/FaceSwapHeader.vue';
import FaceSwapIntroduceSection from '@/components/faceSwapIndex/FaceSwapIntroduceSection.vue';
import FaceSwapGuideSection from '@/components/faceSwapIndex/FaceSwapGuideSection.vue';
import FaceSwapReviewSection from '@/components/faceSwapIndex/FaceSwapReviewSection.vue';
import FaceSwapFAQSection from '@/components/faceSwapIndex/FaceSwapFAQSection.vue';
import FaceSwapEditSection from '@/components/faceSwapIndex/edit/FaceSwapEditSection.vue';
import FaceSwapYTBVideo from '@/components/faceSwapIndex/FaceSwapYTBVideo.vue';
import { uploadFilesVM } from '@/vm/faceswap_vm';
import { ref, onMounted, getCurrentInstance, watch, provide } from 'vue';
import { useFaceSwap } from '@/stores/useFaceSwap';
import { User } from '@/script/user';
import { Config } from '@/script/config';


Config.getInstance.init();
User.getInstance.init();

const { $api, $utility, $analytic, i18n } = getCurrentInstance().appContext.config.globalProperties;
const topNavBarDOMTag = ref(null);
const faceSwap = useFaceSwap();
uploadFilesVM.tabCategory = 0;
faceSwap.init();

const sArg = $utility.getQueryVariable('s');
if (sArg) {
  window.localStorage.setItem('affiliateChildKey', sArg);
  $api.affiliateVisit(sArg);
}

watch(() => faceSwap.selectedFiledIndex, (newV, oldV) => {
  if (oldV == -1 && newV >= 0) {
    $analytic.log('faceswap_preview_express', {
      category: faceSwap.currentSelectedFile.file.fileType == 'video' ? 'video' : 'photo',
      file: faceSwap.currentSelectedFile.file.newFile ? 'new' : 'old',
      demo: faceSwap.currentSelectedFile.file.demoFlag ? '1' : '0',
    });
  }
});

onMounted(() => {
  document
    .querySelector('title')
    .innerText = i18n.global.t('meta.faceswapTab1title');
  document
    .querySelector('meta[name="description"]')
    .setAttribute('content', i18n.global.t('meta.faceswapTab1description'));
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute('content', i18n.global.t('meta.faceswapTab1keywords'));

  $analytic.page = 'faceswap';
  $analytic.log('faceswap_screen_express');
  document.getElementsByTagName('body')[0].style.backgroundImage = `url(${$utility.assetImage('background')})`;
});

provide('tabCategory', 0);
provide('toSignUpHandle', () => {
  topNavBarDOMTag.value.signinClick();
});

</script>

<style lang="scss">
body {
  background-color: #070A14;
  background-position: top;
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0px;
  overscroll-behavior-y: none;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.v-space1 {
  height: 89px;
}
.v-space2 {
  height: 51px;
}
.v-space3 {
  height: 150px;
}
.v-space4 {
  height: 150px;
}
.v-space5 {
  height: 150px;
}
.v-space6 {
  height: 150px;
}
.v-space-extra {
    height: 40px;
  }
@media (max-width: 1070px) {
  .v-space1 {
    height: 66px;
  }
  .v-space2 {
    height: 21px;
  }
  .v-space3 {
    height: 50px;
  }
  .v-space4 {
    height: 50px;
  }
  .v-space5 {
    height: 50px;
  }
  .v-space6 {
    height: 80px;
  }
  .v-space-extra {
    height: 40px;
  }
}
</style>
